import { useEffect } from "react";
import InputWrapper from "../InputWrapper/InputWrapper";

export default function TextInput({
  id,
  label,
  defaultValue,
  register,
  formState,
  wrapperProps,
  useFormMethods,
  attributes,
}) {
  const { errors } = formState;

  useEffect(() => {
    if (defaultValue && useFormMethods) {
      const { setValue } = useFormMethods;
      setValue(id, defaultValue);
    }
  }, [defaultValue, id, useFormMethods]);

  if (!id || !label || !register || !formState) {
    return <p>Could not load this field</p>;
  }

  return (
    <InputWrapper label={label} id={id} formState={formState} {...wrapperProps}>
      <input
        type="text"
        id={id}
        name={id}
        className={`textInput`}
        defaultValue={defaultValue ?? null}
        {...attributes}
        {...register(id)}
        aria-invalid={errors[id] ? "true" : "false"}
      />
    </InputWrapper>
  );
}
